import { Spinner } from '@platform/ui';
import type { INewRecordDraftProps } from './INewRecordDraftProps';
import { NewRecordView } from './NewRecordView';
import { useDraftRecord } from './useDraftRecord';

/** Чернетка нового запису: чекає на типові значення (я, корінь напрямів, поточний спринт, ранг), далі — повна форма в режимі редагування. */
export function NewRecordDraft({ ws, module, rt, nav }: INewRecordDraftProps) {
  const record = useDraftRecord(ws, module, rt, nav.preset);
  if (!record) return <div className="rec__state"><Spinner /></div>;
  return <NewRecordView ws={ws} module={module} rt={rt} record={record} from={nav.from} />;
}
